import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StrapiApiService } from 'app/shared/services/strapi-api.service';
import { TawkToService } from 'app/shared/services/tawk-to.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-detail-page',
  templateUrl: './detail-page.component.html',
  styleUrls: ['./detail-page.component.scss']
})
export class DetailPageComponent implements OnInit {
  tagData: any;
  tagContent: any;
  collection: any;
  content: any = []
  searchTerm: any = [];
  password: string = '';
  term: any;
  @ViewChild('content') myModal: any;
  tags_p: any = [];
  cData: any;
  closeResult = '';
  pt: string | null;
  constructor(public toastr: ToastrService,
    private apiService: StrapiApiService,
    private activatedroute: ActivatedRoute,
    private router: Router,
    private tawkToService: TawkToService,
    private modalService: NgbModal) {
    this.pt = localStorage.getItem('pt');
    this.activatedroute.params.subscribe(data => {
      this.tagData = data;
      if (this.tagData.data) {
        this.searchTerm.push(this.tagData.data)
      } else { this.searchTerm = null }
    })
  }

  copyToClipboard(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.info('Content copied')
  }
  ngOnInit(): void {
    this.getCollectionById();
    this.tawkToService.SetChatVisibility(false);
  }

  open(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getCollectionById() {
    this.apiService.getCollectionContent(this.tagData.id).subscribe((res: any) => {
      if (!this.pt || this.pt == null) {
        this.open(this.myModal);
      }
      this.tags_p = res.rb_tags;
      let content: any = {
        content: ''
      }
      this.cData = res;
      if (localStorage.getItem('pt')) {
        this.collection = this.cData;
      }
    })
  }

  detail() {
    let condition = false
    for (let i in this.tags_p) {
      if (this.password === this.tags_p[i].password_text) {
        condition = true
        localStorage.setItem('pt', '1')
        this.modalService.dismissAll();
        this.collection = this.cData;
      }
    } if (condition == false) {
      this.toastr.error('incorrect password')
    }
    this.password = ''
  }

  selectTag(data: any) {
    var name = data.name;
    name = name.toLowerCase();
    name = name.replace(/ /g, "-");
    name = name.replace(/\?/g, "-");
    this.router.navigate(['research-base/collections/', name, data.id])
  }

  back() {
    history.back();
  }

  ngOnDestroy() {
    localStorage.removeItem('pt');
    this.tawkToService.SetChatVisibility(true);
  }

}
